import React, { useState, useEffect } from 'react';
import styles from './LoginModal.module.css';
import api from '../../../../../api.js';


const LoginModal = ({setAuthModalPage, getMyInfo, marginTop}) => {
	const [id, setId] = useState('');
	const [password, setPassword] = useState('');
	const [isLoginFailed, setIsLoginFailed] = useState(false);
	const [isTooManyAttempt, setIsTooManyAttempt] = useState(false);
	const [isAPIFinish, setIsAPIFinish] = useState(true);

	const handleLoginClick = async () => {
		if (id == '' || password == '') return;
		
		if(isAPIFinish){
			setIsAPIFinish(false);

			try {
				const response = await api.post('/auth/login', {
				user_id: id,
				user_pw: password,
				});
				const { accessToken, refreshToken } = response.data;

				localStorage.setItem('accessToken', accessToken);
				localStorage.setItem('refreshToken', refreshToken);
				setIsLoginFailed(false);
				setAuthModalPage(0);
				getMyInfo();
			} catch (error) {
				if (error.response && error.response.status === 400)
					setIsLoginFailed(true);
				else if (error.response && error.response.status === 429){
					setIsLoginFailed(true);
					setIsTooManyAttempt(true);
				}
				else
					console.error('There was an error login!', error);
			} finally {
				setIsAPIFinish(true);
			}
		}
	};

	useEffect(() => {
		setIsLoginFailed(false);
	}, [id,password]);

	useEffect(() => {
		const idInput = document.getElementById('idInput');
		idInput.focus();
	}, []);

  	return (
		<div className={styles.loginmodal} style={{maxHeight: `calc(100dvh - ${marginTop + 24}px)`, marginTop: `${marginTop}px`}}>
			<div className={styles.header}>
					<div className={styles.loginframe}>
						<div className={styles.registerframe}>
						<div className={styles.logo}>
								<img className={styles.iconfire} alt="" src="images/fire.svg" />
								<img className={styles.hotple2Icon} alt="" src="images/HOTPLE.svg" />
							</div>
							{isLoginFailed ?
								(isTooManyAttempt ?
									<div className={styles.headertext_failed}>로그인 시도 횟수가 너무 많습니다!<br/>1시간 뒤, 다시 시도해주세요.</div>
									:
									<div className={styles.headertext_failed}>ID/PW가 일치하지 않습니다..!</div>
								)
								:
								<div className={styles.headertext}>핫플 로그인하고, 내가 PICK 한 장소 확인!</div>
							}
						</div>
						<div className={styles.loginbox}>
							<div className={styles.logininputs}>
								<div className={styles.idbox}>
									<div className={styles.id}>ID :</div>
									<input
										type="text"
										id="idInput"
										className={styles.idinput}
										placeholder="아이디"
										value={id}
										onChange={(e) => setId(e.target.value)}
										onKeyDown={(e) => {if(e.key === 'Enter'){document.getElementById('passwordInput')?.focus();}}}
									/>
								</div>
								<div className={styles.idbox}>
									<div className={styles.id}>PW :</div>
									<input
										type="password"
										id="passwordInput"
										className={styles.idinput}
										placeholder="비밀번호"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										onKeyDown={(e) => {if(e.key === 'Enter'){handleLoginClick()}}}
									/>
								</div>
							</div>
							<div className={styles.loginbutton} onClick={handleLoginClick}>
								<div className={styles.text}>로그인</div>
							</div>
						</div>
					</div>

					<div className={styles.registerframe}>
						<div className={styles.hotple}>아직 HOTPLE 계정이 없으신가요?</div>
						<div className={styles.kakaobutton} onClick={()=>{
							const redirectUri = `${window.location.origin}/auth/kakao/callback`;

							// scope 필요 없음: 기본 id만 받음 (검수 X)
							window.Kakao.Auth.authorize({ redirectUri });
						}}>
							<img className={styles.iconcloseFilled2} alt="" src="images/kakao.svg" />
							<div className={styles.text}>카카오로 계속하기</div>
						</div>

						<div className={styles.registerbutton} onClick={()=>setAuthModalPage(2)}>
							<img className={styles.iconcloseFilled} alt="" src="images/fire.svg" />
							<div className={styles.text}>HOTPLE 회원가입</div>
						</div>
					</div>
				</div>
			</div>
	);
};

export default LoginModal;
  